module.exports = __webpack_public_path__ + "img/bgmain.9933ca93.9933ca93.png";